<script>
  export let data;
  export let id;

  let { label, handlemodal, handleCollapse } = data;
  $: displayLabel = sanitizeLabelHtml(label);

  function handleClick(e) {
    e.preventDefault();
    handlemodal(e, id);
  }
  function handleClose() {
    handleCollapse(label);
  }

  function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      handleClick(event);
    }
  }

  function cleanTechnicalText(value) {
    const tempTextArea = document.createElement("textarea");
    tempTextArea.innerHTML = value || "";
    return tempTextArea.value
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/[\u200B-\u200D\uFEFF\u00AD]/g, "")
      .replace(/[\u202A-\u202E\u2066-\u2069]/g, "")
      .replace(/\uFFFD/g, "")
      .replace(/<{2,3}\s*([^<>]+?)\s*>{2,3}/g, "$1")
      .replace(/[ \t]+/g, " ");
  }

  function sanitizeLabelHtml(html) {
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html || "";
    const walker = document.createTreeWalker(
      tempDivElement,
      NodeFilter.SHOW_TEXT,
    );
    let node;
    while ((node = walker.nextNode())) {
      node.nodeValue = cleanTechnicalText(node.nodeValue);
    }
    return tempDivElement.innerHTML;
  }
  $$restProps;
</script>

<div class="container">
  <div data-node-id={id} class="group-node">
    <div class="activity-header">
      <span
        class="activity-title"
        on:click={handleClick}
        on:keydown={handleKeyDown}>{@html displayLabel}</span
      >
      <div class="button-collapse">
        <button on:click={handleClose} aria-label="Collapse activity">-</button>
      </div>
    </div>
    <div class="activity-separator"></div>
  </div>
</div>

<style>
  .group-node {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
  }
  .container {
    width: 100%;
    height: 100%;
    z-index: 50;
  }
  .activity-header {
    min-height: 58px;
    display: flex;
    align-items: center;
    padding: 0 58px 0 18px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.28);
    border-radius: 6px 6px 0 0;
  }
  .activity-title {
    display: block;
    max-width: 100%;
    color: #15171d;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.25;
    text-align: left;
    overflow-wrap: anywhere;
  }
  .activity-separator {
    width: 100%;
    height: 1px;
    background: rgba(33, 121, 73, 0.32);
  }
  .button-collapse {
    position: absolute;
    right: 18px;
    top: 13px;
    display: flex;
  }
  .button-collapse button {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1px solid #1c1c20;
    border-radius: 50%;
    background: #fff;
    color: #1c1c20;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
  }
</style>
